@if (isLoading()) {
  <av-loading-item [icon]="'workspace_premium'" [textKey]="'shared.general.labels.loading'" />
} @else {
  <av-content-container class="h-100">
    @if (licenseItems.length != 0) {
      <av-list
      class="list"
      [items]="licenseItems()"
      [selectedItemId]="selectedLicenseId()"
      (itemSelectedId)="selectedLicenseId.set($event)"
      />
    }
    <av-table-card
      [titleKey]="'app.licenses.table.title'"
      [icon]="'workspace_premium'"
      [columns]="selectedLicenseColumns()"
      [rows]="selectedLicenseRows()"
      [pageSize]="10"
      [truncateAfter]="50"
    />
  </av-content-container>
}
